/** Decorative molten-gold curved sweeps — inspired by the CCS banner.
 * Fills its positioned parent edge-to-edge (no interior clipping seams). */

export const GoldCurve = ({ className = "", flip = false, offsetY = 0 }) => (
  <svg
    viewBox="0 0 900 600"
    preserveAspectRatio="none"
    fill="none"
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 w-full h-full ${className}`}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
  >
    <defs>
      <linearGradient id="goldSweepA" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E7B54D" stopOpacity="0" />
        <stop offset="45%" stopColor="#C28A2E" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#8A5D1B" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="goldSweepB" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#F5D88A" stopOpacity="0" />
        <stop offset="50%" stopColor="#E7B54D" stopOpacity="0.9" />
        <stop offset="100%" stopColor="#C28A2E" stopOpacity="0" />
      </linearGradient>
    </defs>
    <g transform={`translate(0, ${offsetY})`}>
      {/* broad soft band */}
      <path
        d="M-120,120 C260,240 560,60 1020,340"
        stroke="url(#goldSweepA)"
        strokeWidth="130"
        strokeLinecap="round"
        opacity="0.16"
        style={{ filter: "blur(6px)" }}
      />
      {/* bright thin ridge */}
      <path
        d="M-120,140 C270,255 570,80 1020,355"
        stroke="url(#goldSweepB)"
        strokeWidth="8"
        strokeLinecap="round"
        opacity="0.5"
      />
      {/* faint companion arc */}
      <path
        d="M-100,240 C300,340 620,180 1020,430"
        stroke="url(#goldSweepA)"
        strokeWidth="46"
        strokeLinecap="round"
        opacity="0.10"
        style={{ filter: "blur(4px)" }}
      />
    </g>
  </svg>
);

export default GoldCurve;
